<template>
  <div id="homeBottomImage" :class="isShowImage?'bottom-ad-enter':'bottom-ad-leave'">
    <div class="homeBottomImage-gray" :class="isShowImage?'bottom-image-enter':'bottom-image-leave'" >
      <ul class="home-bottom-container">
        <div id="home-bottom-contact" class="home-bottom-contact" style="margin-bottom: 0px">
          <img :src="basicInfo.indexBottomImage"/>
        </div>
        <div class="close" @click="closeImage">
          <span>×</span>
        </div>
      </ul>
    </div>
    <div class="homeBottomImage-none"  v-if="!isShowImage">
        <div class="show" @click="showImage">
          <img src="../../assets/pic/show-up-icon.png"/>
        </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { handlePicPlusPre } from "../../util/util";
export default {
  name: "homeBottomImage",
  data() {
    return {
      scrollTop: 0,
      isShowImage: true,
    };
  },
  computed: {
    basicInfo() {
      return this.$store.state.webInfo;
    },
  },
  props: ["message"],
  methods: {
    handlePicPlusPre,
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    // backTop() {
    //   const that = this;
    //   let top = document.documentElement.scrollTop; // 实现滚动效果

    //   const timeTop = setInterval(() => {
    //     document.documentElement.scrollTop = top -= 200;
    //     if (top <= 0) {
    //       clearInterval(timeTop); //清除定时器
    //     }
    //   }, 10);
    // },
    closeButton(){
      this.isshowContact = false;
    },
    showImage() {
      console.log("sss");
      this.isShowImage = true;
    },
    closeImage() {
      this.isShowImage = false;
    },
  },
  mounted() {
    console.log(this.basicInfo.indexBottomImage)
    // window.addEventListener("scroll", this.scrollToTop);
  },
  destroyed() {
    // window.removeEventListener("scroll", this.scrollToTop);
  },
  // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
  // scrollToTop() {
  //   const that = this;
  //   let scrollTop =
  //     window.pageYOffset ||
  //     document.documentElement.scrollTop ||
  //     document.body.scrollTop;
  //   that.scrollTop = scrollTop;
  //   if (that.scrollTop > 60) {
  //     that.btnFlag = true;
  //   } else {
  //     that.btnFlag = false;
  //   }
  // },
};
</script>

<style scoped>
#homeBottomImage{
  position: fixed;
  bottom: 0;
  height: 130px;
  width: 100%;
}
#homeBottomImage .homeBottomImage-gray{
  background: #4c4c4c;
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 2;
}
#homeBottomImage .home-bottom-container .home-bottom-contact {
  display: flex;
  position: relative;
  margin: 0 auto;
  width: 1060px;
  height: 100%;
}
.home-bottom-contact img{
  width: 100%;
  position: absolute;
  height: 140px;
  top: -10px;
}
#homeBottomImage .close{
  color: #fff;
  font-size: 40px;
  position: absolute;
  top: 0px;
  right: 10px;
  cursor: pointer;
}
#homeBottomImage .no-show{
  display: none;
}
#homeBottomImage .homeBottomImage-none{
  background: #0000;
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: right;
  z-index: 1;
} 

#homeBottomImage .show{
  color: #fff;
  font-size: 24px;
  position: absolute;
  right: 15px;
  bottom: 0;
  cursor: pointer;
} 

#homeBottomImage .show img{
  width: 20px;
  height: 20px;
} 
</style>
<style scoped>
.bottom-image-enter {
   animation: bottom-image-enter 1s 1;
}
 
.bottom-image-leave {
   bottom: -130px;
   opacity: 0;
   animation: bottom-image-leave 1s 1;
}
@keyframes bottom-image-enter{
       0% {
          bottom:-130px;
       }
       100% {
          bottom:0;
       }
}
@keyframes bottom-image-leave{
      0% {
          bottom:0;
          opacity: 1;
       }
       90%{
        opacity: 1;
       }
       100% {
          bottom:-130px;
          opacity: 0;
       }
}

/* .bottom-ad-enter {
   animation: bottom-ad-enter 1s 1;
   height: 130px!important;
} */
 
.bottom-ad-leave {
   max-height: 0;
   animation: bottom-ad-leave 2s 1;
}

@keyframes bottom-ad-enter{
       0% {
          height:0px;
       }
       100% {
          height:130px;
       }
}
@keyframes bottom-ad-leave{
       0% {
          max-height:130px;
       }
       100% {
          max-height:0px;
       }
}
</style>



// WEBPACK FOOTER //
// src/components/comment/homeBottomImage.vue